export default __webpack_public_path__ + "static/media/GMC.1354571d.svg";